import { strIsNullOrEmpty, TextField, tryParseJSONObject } from '@fox/atoms';
import { ActionCentreFilterProps, StringFilterValue } from './contracts';
export function StringFilter({ column, onChange, filter }: ActionCentreFilterProps) {
	const parsedValue = filter?.filterValue ? tryParseJSONObject<StringFilterValue>(filter?.filterValue) : undefined;
	return (
		<TextField
			value={parsedValue?.contains ?? ''}
			onChange={e => {
				if (!strIsNullOrEmpty(e.target.value)) {
					onChange(JSON.stringify({ contains: e.target.value }));
				} else {
					onChange(undefined);
				}
			}}
			size="small"
			placeholder={column.title}
		/>
	);
}
